
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advice/[uid]",
      function () {
        return require("private-next-pages/advice/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advice/[uid]"])
      });
    }
  